// CRM 2.0 · M12 Template Builder · "Which fields do you want?" for Buyer details and Signatures: Legal ticks the buyer
// fields in the order she wants them (or moves / removes them); the system then fills the spaces in that order.
// Buyer details: matched by field (spaces = the buyer lines' spaces with their field now): a ticked field keeps its
// space, the salutation is added in front of the name, a field not ticked prints once, for buyer 1.
// Signatures: the fields of each applicant's line (a salutation goes in front of the name; more fields add spaces).
import React, { useState } from "react";
import cls from "./Templates.module.css";

function FieldOrderModal({ title, hint, fields, initial, spaces = null, saveLabel = "Set up", onSave, onCancel }) {
  const buyerFields = fields.filter((f) => f.repeatKind === "EACH_APPLICANT");
  const [order, setOrder] = useState(() => (initial || []).filter((k) => buyerFields.some((f) => f.key === k)));
  const [q, setQ] = useState("");
  const labelOf = (k) => fields.find((f) => f.key === k)?.label || k;
  const toggle = (k) => setOrder((list) => (list.includes(k) ? list.filter((x) => x !== k) : [...list, k]));
  const move = (i, d) => setOrder((list) => { const next = [...list]; const j = i + d; if (j < 0 || j >= next.length) return list; [next[i], next[j]] = [next[j], next[i]]; return next; });
  const shown = buyerFields.filter((f) => !q.trim() || f.label.toLowerCase().includes(q.trim().toLowerCase()));
  // buyer details: where each ticked field goes, and the fields on the page that are not ticked
  // what each space is: the word before it on the page says it, else its field now
  const onPage = new Set((spaces || []).map((s) => s.byWords || s.fieldKey).filter(Boolean));
  const emptySpaces = (spaces || []).filter((s) => !(s.byWords || s.fieldKey)).length;
  const whereOf = (k) => (onPage.has(k) ? "on its space" : k === "buyer.salutation" ? "added in front of the name" : emptySpaces ? "goes to an empty space" : "no space for it on the page");
  const notTicked = [...onPage].filter((k) => !order.includes(k));

  return (
    <div className={cls.mask} role="dialog" aria-modal="true" aria-label={title} onClick={onCancel}>
      <div className={cls.modal} style={{ maxWidth: "72rem" }} onClick={(e) => e.stopPropagation()}>
        <div className={cls.modalHead}><h2>{title}</h2></div>
        <div className={cls.modalBody}>
          {hint && <p className={cls.hint} style={{ marginTop: 0 }}>{hint}</p>}
          <div className={cls.orderGrid}>
            <div>
              <p className={cls.lbl}>Your fields, in order</p>
              {!order.length && <p className={cls.hint}>Tick fields on the right.</p>}
              {order.map((k, i) => (
                <div key={k} className={cls.colRow}>
                  <b style={{ width: "2.4rem" }}>{i + 1}</b>
                  <span style={{ flex: 1 }}>{labelOf(k)}{spaces ? <span className={cls.hint} style={{ margin: 0 }}> · {whereOf(k)}</span> : null}</span>
                  <button type="button" className={cls.link} disabled={i === 0} onClick={() => move(i, -1)} aria-label="Up">↑</button>
                  <button type="button" className={cls.link} disabled={i === order.length - 1} onClick={() => move(i, 1)} aria-label="Down">↓</button>
                  <button type="button" className={cls.link} onClick={() => toggle(k)} aria-label={`Remove ${labelOf(k)}`}>×</button>
                </div>
              ))}
              {spaces && notTicked.length > 0 && (
                <div className={cls.sugBox} style={{ marginTop: ".8rem" }}>
                  Not ticked, so printed once, for buyer 1 only: {notTicked.map(labelOf).join(", ")}.
                </div>
              )}
            </div>
            <div>
              <input className={cls.optInp} placeholder="Search buyer fields" value={q} onChange={(e) => setQ(e.target.value)} aria-label="Search buyer fields" />
              <div className={cls.orderList}>
                {shown.map((f) => (
                  <label key={f.key} className={cls.chk} style={{ padding: ".3rem 0" }}>
                    <input type="checkbox" checked={order.includes(f.key)} onChange={() => toggle(f.key)} />
                    {order.includes(f.key) ? <b>{order.indexOf(f.key) + 1}.</b> : null} {f.label}
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className={cls.modalFoot}>
          <button className={cls.btn} onClick={onCancel}>Cancel</button>
          <button className={`${cls.btn} ${cls.primary}`} disabled={!order.length} onClick={() => onSave(order)}>{saveLabel}</button>
        </div>
      </div>
    </div>
  );
}

export default FieldOrderModal;
